import {
  returnSlideArrayFromXml,
  returnLowerthirdsArrayFromXml,
  returnShowMetaDataFromXml
} from "@/utils/sharedWithPlayer/soundslidesDataXml";

import {
  returnSlideArrayFromTxt,
  returnLowerthirdsArrayFromTxt,
  returnShowMetaDataFromTxt
} from "@/utils/sharedWithPlayer/soundslidesDataTxt";

import each from "lodash/each";
import pickBy from "lodash/pickBy";
import identity from "lodash/identity";
import isUndefined from "lodash/isUndefined";

function returnDisplaySettingsFromMetaDict(metaDict) {
  // The metaDict is legacy. The displaySettings is the future.
  // We need to cherry-pick the meta variables for inclusion into displaySettings.
  function toBoolean(v) {
    return v === "true";
  }
  function toInt(v) {
    return parseInt(v, 10);
  }
  function toFloat(v) {
    return parseFloat(v);
  }
  var inclusionMapArray = [
    {
      legacyName: "transition_time",
      newName: "globalTransitionTime",
      transform: toFloat
    },
    { legacyName: "transition_type", newName: "globalTransitionType" },
    {
      legacyName: "body_hex",
      newName: "globalBackgroundColor",
      transform: v => {
        return "#" + v;
      }
    },
    {
      legacyName: "custom_width",
      newName: "customWidth",
      transform: toInt
    },
    {
      legacyName: "custom_height",
      newName: "customHeight",
      transform: toInt
    },
    {
      legacyName: "header_headline",
      newName: "title",
      transform: title => {
        if (title) {
          return title;
        }
        return "";
      }
    },
    {
      legacyName: "credits",
      newName: "credits",
      transform: credits => {
        if (credits) {
          return credits;
        }
        return "";
      }
    },
    {
      legacyName: "seconds_per_image",
      newName: "fakeAudioPlaybackSecsPerImage",
      transform: toFloat
    },
    {
      legacyName: "slide_only",
      newName: "noAudio",
      transform: toBoolean
    },
    {
      legacyName: "showCaptions",
      newName: "showCaptions",
      transform: toBoolean
    },
    {
      legacyName: "showCredits",
      newName: "showCredits",
      transform: toBoolean
    },
    {
      legacyName: "display_header",
      newName: "showTitle",
      transform: toBoolean
    }
  ];
  var displaySettings = {};
  each(inclusionMapArray, i => {
    if (i.legacyName in metaDict) {
      if ("transform" in i) {
        displaySettings[i.newName] = i.transform(metaDict[i.legacyName]);
      } else {
        displaySettings[i.newName] = metaDict[i.legacyName];
      }
    }
  });
  if (displaySettings.noAudio) {
    // Must have "fakeAudioPlaybackSecsPerImage" if noAudio.
    var defaultIfNoPlaybackSecsPerImage = 4;
    if (!displaySettings.fakeAudioPlaybackSecsPerImage) {
      displaySettings.fakeAudioPlaybackSecsPerImage = defaultIfNoPlaybackSecsPerImage;
    }
  }

  // Add some missing defaults (audioDurationOverride defaults need to exist before editor loads).
  displaySettings.audioDurationOverride = 0;
  displaySettings.audioDurationOverrideEnabled = false;

  return displaySettings;
}

export const processXmlDataToShow = (show_obj, xmlstring) => {
  var metaDict = returnShowMetaDataFromXml(xmlstring);
  show_obj.data.slideArray = returnSlideArrayFromXml(xmlstring);
  // Add source id to slideArray.
  show_obj.data.slideArray = show_obj.data.slideArray.map(i => {
    i.source_id = show_obj.key;
    return i;
  });
  show_obj.data.autoTimeEnabled = false;
  show_obj.data.displaySettings = returnDisplaySettingsFromMetaDict(metaDict);
  show_obj.data.overlayArray = returnLowerthirdsArrayFromXml(xmlstring);
  show_obj.data.v1MetaDict = pickBy(metaDict, identity);
  // Add the title to the show object.
  if (
    !isUndefined(show_obj.data.v1MetaDict.header_headline) &&
    show_obj.data.v1MetaDict.header_headline != ""
  ) {
    show_obj.title = show_obj.data.v1MetaDict.header_headline;
  }
};

export const processTxtDataToShow = (show_obj, txtstring) => {
  var metaDict = returnShowMetaDataFromTxt(txtstring);
  show_obj.data.slideArray = returnSlideArrayFromTxt(txtstring);
  console.log("slideArray", show_obj.data.slideArray);
  // Add source id to slideArray.
  show_obj.data.slideArray = show_obj.data.slideArray.map(i => {
    i.source_id = show_obj.key;
    return i;
  });
  show_obj.data.autoTimeEnabled = false;
  show_obj.data.displaySettings = returnDisplaySettingsFromMetaDict(metaDict);
  show_obj.data.overlayArray = returnLowerthirdsArrayFromTxt(txtstring);
  show_obj.data.v1MetaDict = pickBy(metaDict, identity);
  // Add the title to the show object.
  // Add the title to the show object.
  if (
    !isUndefined(show_obj.data.v1MetaDict.header_headline) &&
    show_obj.data.v1MetaDict.header_headline != ""
  ) {
    show_obj.title = show_obj.data.v1MetaDict.header_headline;
  }
};
